// extracted by mini-css-extract-plugin
export default {"section":"jFg8g","largeViewport":"vmgi8"};